<template>
    <div id="e-conference">
        <div v-if="econference != null" class="locator__place-extended-download">
            <h3 class="locator__place-extended-title">
                <a @click="isActive = !isActive"
                   class="btn  has-tooltip-bottom"
                   :data-tooltip="tooltipText"> {{
                   buttonName() ? econference.button: $t('e_conference') }}</a></h3>
        </div>
        <modal :isActive="isActive" :content="'asd'" @update-modal="update">
            <eConferenceForm :institutionId="institutionId" @form-result="formResult"></eConferenceForm>
        </modal>
    </div>
</template>

<script>
    import modal from "./modal";
    import eConferenceForm from './forms/conference-form'
    import Swal from 'sweetalert2'

    export default {
        name: "e-conference",
        props: ['econference', 'institutionId'],
        components: {
            modal,
            eConferenceForm
        },
        data() {
            return {
                isActive: false,
                tooltipText: ''
            };
        },
        mounted() {
            if (this.econference != null) {
                this.tooltipText = this.econference.tooltip;
            }

        },
        methods: {
            buttonName(){
              return this.econference !== null && this.econference.hasOwnProperty('button');
            },
            update(state) {
                this.isActive = state;
            },
            formResult(state) {
                let icon = state ? 'success' : 'error';
                let message = state ? 'Formularz został wysłany<br />Odbierz swoją pocztę e-mail' : 'Wystąpił błąd, spróbuj ponownie';
                let html = state ? "" : 'Skontaktuj się z administratorem'
                Swal.fire(
                    message,
                    html,
                    icon
                );
                this.isActive = false
            }
        }

    };
</script>

<style>
    [data-tooltip]:hover:before,
    [data-tooltip]:hover:after {
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.5);
        font-size: 13px;
        min-width: 220px;
        font-weight: bold;
        color: #FFF;
        margin-bottom: 12px;
        text-transform: uppercase;
        white-space: normal;
        padding: 30px;
    }
</style>
